var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7458 25.6275C15.4918 25.6496 16.2242 25.8315 16.8929 26.1609H16.9332C17.4918 26.6167 17.5868 27.4303 17.1479 28.001C16.3488 29.1446 15.0701 29.8656 13.6722 29.961C12.236 30.1323 10.7897 29.7347 9.64637 28.8543C9.05835 28.4511 8.67622 27.8134 8.59965 27.1076C8.59965 26.3609 9.29746 26.0142 9.9416 25.8676C10.6961 25.7086 11.4651 25.6282 12.2363 25.6275H14.7458ZM13.0549 0C17.6981 0 22.4888 3.36012 22.9854 8.22695C23.0659 9.22698 22.9854 10.267 23.0659 11.2804C23.3294 12.5872 23.9358 13.8016 24.8238 14.8005C25.3759 15.6214 25.6957 16.5747 25.7499 17.5606V17.8673C25.758 19.1976 25.2814 20.4859 24.4078 21.4941C23.3007 22.6779 21.7985 23.4218 20.1807 23.5875C15.4008 24.2008 10.5614 24.2008 5.78155 23.5875C4.14467 23.4344 2.62135 22.6894 1.50072 21.4941C0.654591 20.4762 0.21089 19.1868 0.252708 17.8673V17.5606C0.305077 16.5784 0.615033 15.6269 1.15182 14.8005C2.04378 13.8007 2.65882 12.5876 2.93661 11.2804C3.01713 10.267 2.93661 9.24032 3.01713 8.22695C3.52707 3.36012 8.2239 0 12.9207 0H13.0549Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.d2a08540fea7ea5a17f371d3ed7173c2.svg";
export { ForwardRef as ReactComponent };